import { render, staticRenderFns } from "./AdmissionsSync.vue?vue&type=template&id=38d4ed7b"
import script from "./AdmissionsSync.vue?vue&type=script&lang=js"
export * from "./AdmissionsSync.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38d4ed7b')) {
      api.createRecord('38d4ed7b', component.options)
    } else {
      api.reload('38d4ed7b', component.options)
    }
    module.hot.accept("./AdmissionsSync.vue?vue&type=template&id=38d4ed7b", function () {
      api.rerender('38d4ed7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsSync.vue"
export default component.exports